import * as React from "react";
import { IButtonEvents } from "../_common/buttonEvents";
import { Label } from "./components/Label";
import { Wrapper } from "./components/Wrapper";

export interface ISettingButton extends IButtonEvents {
  disabled?: boolean;
  label?: string;
  active?: boolean;
  theme?: any;
}

export const SettingButton = ({ label, ...props }: ISettingButton) => (
  <Wrapper {...props}>
    <Label active={props.active}>{label}</Label>
  </Wrapper>
);
